import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoImage from "../images/logo.png";
import { trackEvent } from "../helpers/trackEvent";
import AuthSuccessPanel from "./AuthSuccessPanel";
import { useAuth } from "./AuthContext";
import "./Auth.css";

const ForgotPasswordPage = () => {
  const { isConfigured, sendPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setNotice("");
    setIsSubmitting(true);

    try {
      await sendPasswordReset(email);
      trackEvent({
        action: "password_recovery_request",
        data: {
          method: "email",
        },
      });
      setNotice("Password reset instructions were sent if that email has an account.");
    } catch (submitError) {
      setError(submitError.message || "Could not send password reset instructions.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <Link className="auth-logo" to="/login">
          <img src={logoImage} alt="BadgeFlow logo" />
        </Link>
        <h1>Reset your password</h1>

        {notice ? (
          <AuthSuccessPanel
            actionLabel="Back to sign in"
            actionTo="/login"
            title="Reset link sent"
          >
            <p>
              We sent a secure password reset link to <strong>{email}</strong>.
              Open it to choose a new password.
            </p>
          </AuthSuccessPanel>
        ) : (
          <>
            <p className="auth-description">Enter your email and we will send a secure password reset link.</p>

            {error && <div className="auth-alert" role="alert">{error}</div>}

            <form className="auth-form" onSubmit={handleSubmit}>
              <label htmlFor="reset-email">Email address</label>
              <input
                id="reset-email"
                autoComplete="email"
                inputMode="email"
                onChange={(event) => setEmail(event.target.value)}
                required
                type="email"
                value={email}
              />
              <button className="primary auth-submit" disabled={isSubmitting || !isConfigured} type="submit">
                {isSubmitting ? "Sending…" : "Send reset link"}
              </button>
            </form>

            <p className="auth-switch"><Link to="/login">Back to sign in</Link></p>
          </>
        )}
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
